/**
 * @Author: v_jppjpeng
 * @Date: 2024-11-10 14:46:09
 * @Explain: 活动 - 周期
 */
export interface ActivityCycleState {
  /** 是否显示创建周期活动 - 弹窗 */
  createCycleOptions: {
    isShow: boolean;
  };
  /** 是否内部跳转 */
  isInternalJump: boolean;
  /** 是否开启跳出拦截 */
  isLeaveFlag: boolean;
  /** 选择内容 - 语言tab选中项 */
  languageActive: string;
  /** 草稿缓存 */
  draftCache: {
    id: number;
    tag: string;
    time: 0;
    saveList: any[];
    expandedList: any[];
  };
}

export interface ActivityCycleReducers {
  setCreateCycleOptions: (
    state: ActivityCycleState,
    action: { payload: any },
  ) => any;
  setInterceptRouteStatus: (
    state: ActivityCycleState,
    action: { payload: any },
  ) => any;
  setTabsActive: (state: ActivityCycleState, action: { payload: any }) => any;
  setDraftCache: (state: ActivityCycleState, action: { payload: any }) => any;
  resetDraftCache: (state: ActivityCycleState, action: { payload: any }) => any;
}

export type ModelType = {
  namespace: string;
  state: ActivityCycleState;
  reducers: ActivityCycleReducers;
};

const ActivityCycleModel: ModelType = {
  namespace: 'ActivityCycleModel',
  state: {
    // 是否显示创建周期活动 - 弹窗
    createCycleOptions: {
      isShow: false,
    },
    // 是否内部跳转
    isInternalJump: false,
    // 是否开启跳出拦截
    isLeaveFlag: false,
    // 选择内容 - 语言tab选中项
    languageActive: '',
    // 草稿缓存
    draftCache: {
      id: 0,
      tag: '',
      time: 0,
      saveList: [],
      expandedList: [],
    },
  },
  reducers: {
    // 设置周期活动 - 弹窗配置
    setCreateCycleOptions(state, action) {
      return {
        ...state,
        createCycleOptions: action.payload,
      };
    },
    // 设置拦截路由状态
    setInterceptRouteStatus(state, action) {
      const { isInternalJump, isLeaveFlag } = action.payload;
      return {
        ...state,
        isInternalJump,
        isLeaveFlag,
      };
    },
    // 设置选择内容 - 语言tab选中项
    setTabsActive(state, action) {
      return {
        ...state,
        languageActive: action.payload,
      };
    },
    // 设置草稿缓存
    setDraftCache(state, action) {
      return {
        ...state,
        draftCache: action.payload,
      };
    },
    // 重置草稿缓存
    resetDraftCache(state, action) {
      return {
        ...state,
        draftCache: {
          id: 0,
          time: 0,
          saveList: [],
          expandedList: [],
        },
        languageActive: '',
      };
    },
  },
};

export default ActivityCycleModel;
